import React, { useEffect, useRef } from 'react';
import { exchangeSessionId } from '../lib/auth';
import { useAuth } from '../contexts/AuthContext';

export const AuthCallback = () => {
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double-execution under React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      // No session_id — clear hash and let normal flow handle it
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      window.location.reload();
      return;
    }

    exchangeSessionId(sessionId)
      .then((user) => {
        setUser(user);
        // Strip the session_id from the URL
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      })
      .catch((err) => {
        console.error('Auth exchange failed:', err);
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
        window.location.reload();
      });
  }, [setUser]);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0a1628 0%, #1a1d29 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#cbd5e1',
        fontFamily: 'Inter, sans-serif',
      }}
      data-testid="auth-callback"
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            width: 40,
            height: 40,
            border: '3px solid rgba(94, 234, 212, 0.2)',
            borderTopColor: '#5eead4',
            borderRadius: '50%',
            margin: '0 auto 16px',
            animation: 'spin 0.8s linear infinite',
          }}
        />
        <div style={{ fontSize: 14, letterSpacing: '0.1em', textTransform: 'uppercase' }}>
          Signing you in…
        </div>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default AuthCallback;
